import { render } from "./CreateAssignmentModal.vue?vue&type=template&id=48b1c3e4"
import script from "./CreateAssignmentModal.vue?vue&type=script&lang=js"
export * from "./CreateAssignmentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__